import styled from 'styled-components';

export const StyledTexWrapper = styled.div`
  margin-top:-8px;
  margin-bottom:36px;
`;
